
/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Type Mst Interface
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';

export interface ItemTypeParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface ItemType {
  id?:number;
  code:string;
  name:string;
  description: string;
  itemCategoryId:number;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  tenantId:any;
  createdIP:string;
  updatedIP:string;
  serviceId:string;
  parameters?: ItemTypeParameter[];
  links?: any;
}

export abstract class ItemTypeData { 
  abstract list(url: string): Observable<ItemType[]>;
  abstract create(url: string,data: ItemType): Observable<any>;
  abstract update(url: string,data: ItemType): Observable<any>;
  abstract delete(url: string): Observable<any>;
}